import { jsx as _jsx } from "react/jsx-runtime";
import { Folder, Timer, TravelExplore } from "@mui/icons-material";
import { EmptyState } from "../../shared/EmptyState";
export const PriorityViewPreviewEmptyState = ({ onPreviewPriorityView }) => {
    return (_jsx(EmptyState, { backgroundIcon: Folder, primaryIcon: TravelExplore, accentIcon: Timer, title: "Preview is Empty", description: "Add filters to preview your referral pipeline.", paddingBottom: "10rem", action: onPreviewPriorityView
            ? {
                label: "Preview Priority View",
                onClick: onPreviewPriorityView
            }
            : undefined }));
};
